import Vue from 'vue'
import VueRouter from 'vue-router'
import {
  Alert,
  Aside,
  Autocomplete,
  Badge,
  Button,
  ButtonGroup,
  Card,
  Col,
  ColorPicker,
  Container,
  Divider,
  Dialog,
  Form,
  FormItem,
  Image,
  Input,
  Link,
  Main,
  Menu,
  MenuItem,
  Message,
  Option,
  OptionGroup,
  Radio,
  RadioGroup,
  Row,
  Select,
  Scrollbar,
  Slider,
  Submenu,
  Switch,
  Table,
  TableColumn,
  TabPane,
  Tabs,
  Tooltip,
  MessageBox, Loading
} from 'element-ui'

const elMessage = Message
const elMessageBox = MessageBox
const elLoading = Loading

import axios from 'axios'
import VueClipboard from 'vue-clipboard2'

import * as i18n from './i18n'
import App from './App'
import Layout from './layout'
import Home from './views/Home'
import StyleGenerator from './views/StyleGenerator'
import Help from './views/Help'
import Room from './views/Room'
import NotFound from './views/NotFound'
import './theme.less'
import ClientHome from './views/client/Home'
import Setting from "@/views/client/Setting"
import ClientHelp from '@/views/client/Help'
import ClientRoom from '@/views/client/Room'
import GiftRoom from "@/views/client/GiftRoom"
import GiftSetting from "@/views/client/GiftSetting"

axios.defaults.timeout = 10 * 1000
// axios.defaults.baseURL = "https://xfd.xiaofaduoshiyanshi.com"

Vue.use(VueRouter)
// 初始化element
Vue.use(Alert)
Vue.use(Aside)
Vue.use(Autocomplete)
Vue.use(Badge)
Vue.use(Button)
Vue.use(ButtonGroup)
Vue.use(Card)
Vue.use(Col)
Vue.use(ColorPicker)
Vue.use(Container)
Vue.use(Divider)
Vue.use(Dialog)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Image)
Vue.use(Input)
Vue.use(Link)
Vue.use(Main)
Vue.use(Menu)
Vue.use(MenuItem)
Vue.use(Option)
Vue.use(OptionGroup)
Vue.use(Radio)
Vue.use(RadioGroup)
Vue.use(Row)
Vue.use(Select)
Vue.use(Scrollbar)
Vue.use(Slider)
Vue.use(Submenu)
Vue.use(Switch)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(TabPane)
Vue.use(Tabs)
Vue.use(Tooltip)
Vue.use(elLoading.directive)

Vue.prototype.$message = elMessage
Vue.prototype.$msgbox = elMessageBox
Vue.prototype.$confirm = elMessageBox.confirm
Vue.prototype.$loading = elLoading.service

Vue.config.ignoredElements = [/^yt-/]

VueClipboard.config.autoSetContainer = true
Vue.use(VueClipboard)

const routePropsFun = route => {
  let roomKeyType = parseInt(route.query.roomKeyType) || 1
  if (roomKeyType < 1 || roomKeyType > 2) {
    roomKeyType = 1
  }

  let roomKeyValue = route.params.roomKeyValue
  if (roomKeyType === 1) {
    roomKeyValue = parseInt(roomKeyValue) || null
  } else {
    roomKeyValue = roomKeyValue || null
  }
  return { roomKeyType, roomKeyValue, strConfig: route.query }
}

const router = new VueRouter({
  mode: 'history',
  routes: [
    {
    path: '/',
    name: 'clientHome',
    component: ClientHome,
    children: [{
        path: '',
        name: 'clientSetting',
        component: Setting
      },
      {
        path: '/help',
        name: 'clientHelp',
        component: ClientHelp
      },
      {
        path: '/giftSetting',
        name: 'clientHelp',
        component: GiftSetting
      }]
    },
    {
      path: '/client/room/test',
      name: 'client_test_room',
      component: ClientRoom,
      props: route => ({ strConfig: route.query })
    },
    {
      path: '/client/room/:roomKeyValue',
      name: 'client_room',
      component: ClientRoom,
      props(route) {
        return routePropsFun(route)
      }
    },
    {
      path: '/admin',
      component: Layout,
      children: [
        {
          path: '',
          name: 'home',
          component: Home
        },
        {
          path: 'stylegen',
          name: 'stylegen',
          component: StyleGenerator
        },
        {
          path: 'help',
          name: 'help',
          component: Help
        }
      ]
    },
    {
      path: '/admin/room/test',
      name: 'test_room',
      component: Room,
      props: route => ({ strConfig: route.query })
    },
    {
      path: '/admin/room/:roomKeyValue',
      name: 'room',
      component: Room, props(route) {
        return routePropsFun(route)
      }
    },
    {
      path: '/client/giftRoom/test',
      name: 'gift_test_room',
      component: GiftRoom,
      props: route => ({ strConfig: route.query })
    },
    {
      path: '/client/giftRoom/:roomKeyValue',
      name: 'gift_room',
      component: GiftRoom,
      props(route) {
        return routePropsFun(route)
      }
    },
    {
      path: '*',
      component: NotFound
    }
  ]
})

new Vue({
  render: h => h(App), router, i18n: i18n.i18n
}).$mount('#app')
